import { createApp } from "vue";
// import "vant/lib/index.css";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission";
import 'element-plus/theme-chalk/dark/css-vars.css'
import "@/style/index.scss";
import "@/style/global.scss";
import "@/style/reset.css";
import InfiniteScroll from "element-plus";
import Container from "@/views/operate/components/Container.vue";
import CourseItem from "@/views/operate/components/index/CourseItem.vue";
import TLoading from "@/views/operate/components/TLoading.vue";
import { i18n } from "./language/local"; 
// import VConsole from "vconsole";
// const Vconsole = new VConsole();
import { isNewDomain } from "@/utils";
import Tea from "@dp/byted-tea-sdk-oversea";

import { vCdnSimple as vCdn } from '@/directives/vCdn';

Tea.init({
  app_id: 491147,
  channel: "sg",
  channel_domain: isNewDomain() ? "https://www.tiktokforbusiness-learning-center.com": "https://mcs-sg.tiktokv.com",
  channel_type: "tcpy", // 如果你是Tik Tok或者musically业务这个参数一定要设置
  // caller: "ad.se.tt4b_academy_api",
  enable_stay_duration: true,
});
const uid = localStorage.getItem("tt4b_academy_uid");
const userType = localStorage.getItem("tt4b_academy_type");
const username = localStorage.getItem("tt4b_academy_username");
if (uid && userType && username) {
  Tea.config({
    user_id: uid,
    user_type: parseInt(userType),
    user_is_login: 1,
    evtParams: {
      tt4b_uid: uid,
      tt4b_username: username,
      tt4b_user_type: userType,
    },
  });
} else {
  Tea.config({
    user_is_login: 0,
  });
}
Tea.start();

const app = createApp(App)
  .component("Container", Container)
  .component("CourseItem", CourseItem)
  .component("TLoading", TLoading) 
  .use(i18n)
  .use(InfiniteScroll)
  .use(store)
  .use(router);

  app.directive('cdn', vCdn);
app.mount("#app"); 